export const version = 'kunde-v1.20.0-SNAPSHOT-ecc355ae6127ef55fce1d098ce3b7891e7be7c4d';